import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ac6e998"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "importSubprocessModule",
  tabindex: "-1",
  "data-bs-backdrop": "true",
  "aria-labelledby": "importSubprocessModule",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Import Sub Process", -1))
const _hoisted_6 = {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close",
  ref: "closeBtn"
}
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = {
  key: 0,
  id: "page1"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "You can import a sub-process that matches the process into this project at a later date.", -1))
const _hoisted_10 = { class: "mt-3" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "form-label"
}, [
  /*#__PURE__*/_createElementVNode("b", null, "Source Sub Process")
], -1))
const _hoisted_12 = {
  selected: "",
  value: ""
}
const _hoisted_13 = ["value"]
const _hoisted_14 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "form-label"
}, [
  /*#__PURE__*/_createElementVNode("b", null, "Start / End Date")
], -1))
const _hoisted_16 = { class: "dates-view" }
const _hoisted_17 = { class: "d-flex" }
const _hoisted_18 = { class: "pe-1" }
const _hoisted_19 = { class: "ps-1" }
const _hoisted_20 = {
  key: 0,
  class: "mb-0 mt-2 pe-5"
}
const _hoisted_21 = {
  key: 1,
  id: "page2",
  class: ""
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "form-label"
}, [
  /*#__PURE__*/_createElementVNode("b", null, "Placeholder Matching")
], -1))
const _hoisted_23 = { class: "roles-view" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "mt-3 mb-3" }, "No placeholders have been used in the template so far.", -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = {
  key: 2,
  id: "page3",
  class: "pt-3"
}
const _hoisted_30 = { class: "modal-footer" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = {
  key: 1,
  class: "w-100"
}
const _hoisted_33 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_select_date = _resolveComponent("select-date")!
  const _component_feather_icon = _resolveComponent("feather-icon")!
  const _component_LogoAndName = _resolveComponent("LogoAndName")!
  const _component_user_selection = _resolveComponent("user-selection")!
  const _component_loading_spinner = _resolveComponent("loading-spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("button", _hoisted_6, null, 512)
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_ctx.page === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _withDirectives(_createElementVNode("select", {
                    class: "form-control",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedSubProcessId) = $event))
                  }, [
                    _createElementVNode("option", _hoisted_12, _toDisplayString(_ctx.selectedSubProcessId ? 'Deselect the' : 'Select a') + " sub process", 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subprocesses, (subprocess) => {
                      return (_openBlock(), _createElementBlock("option", {
                        selected: "",
                        value: subprocess.processId,
                        key: subprocess.processId
                      }, _toDisplayString(subprocess.name), 9, _hoisted_13))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.selectedSubProcessId]
                  ])
                ]),
                (_ctx.selectedSubProcessId)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _hoisted_15,
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createVNode(_component_select_date, {
                              initialDate: _ctx.startDate,
                              onSelectDate: _cache[1] || (_cache[1] = ($event: any) => (_ctx.startDate = $event)),
                              hideInputIcon: true
                            }, null, 8, ["initialDate"])
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            _createVNode(_component_select_date, {
                              initialDate: _ctx.endDate,
                              onSelectDate: _cache[2] || (_cache[2] = ($event: any) => (_ctx.endDate = $event)),
                              hideInputIcon: true
                            }, null, 8, ["initialDate"])
                          ])
                        ])
                      ]),
                      (_ctx.process.metaData.projectStart)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_20, " The start and end dates are taken from the main process, but you can overwrite them. "))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.page === 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("div", _hoisted_23, [
                  (!_ctx.placeholders.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_26))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.placeholders, (placeholder) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: placeholder.placeholderId,
                      class: "user-selection-wrapper mb-2"
                    }, [
                      _createVNode(_component_user_selection, {
                        selectedUsers: _ctx.selectedPlaceholder[placeholder.placeholderId],
                        "onUpdate:selectedUsers": ($event: any) => ((_ctx.selectedPlaceholder[placeholder.placeholderId]) = $event),
                        exactlyOne: true,
                        hidePlaceholder: true,
                        label: "Placeholder Matching"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.selectedPlaceholder[placeholder.placeholderId] && _ctx.selectedPlaceholder[placeholder.placeholderId].length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                _createTextVNode(_toDisplayString(placeholder.name) + ": ", 1),
                                _createVNode(_component_feather_icon, {
                                  type: "trash",
                                  stroke: "rgba(31, 50, 69, 0.5)",
                                  size: "16",
                                  class: "mt-1 float-end",
                                  onClick: ($event: any) => (_ctx.selectedPlaceholder[placeholder.placeholderId] = [])
                                }, null, 8, ["onClick"]),
                                _createVNode(_component_LogoAndName, {
                                  user: _ctx.selectedPlaceholder[placeholder.placeholderId][0],
                                  rowView: true
                                }, null, 8, ["user"])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                _createTextVNode(_toDisplayString(placeholder.name) + " ", 1),
                                _createVNode(_component_feather_icon, {
                                  type: "chevron-right",
                                  stroke: "rgba(31, 50, 69, 0.5)",
                                  size: "20",
                                  class: "float-end"
                                })
                              ]))
                        ]),
                        _: 2
                      }, 1032, ["selectedUsers", "onUpdate:selectedUsers"])
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.page === 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createVNode(_component_loading_spinner, {
                  text: `Importing: ${_ctx.percentage.toFixed()}%`
                }, null, 8, ["text"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_30, [
          (_ctx.page == 1)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-primary ms-2",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.page = 2)),
                disabled: !_ctx.selectedSubProcessId
              }, " Next ", 8, _hoisted_31))
            : _createCommentVNode("", true),
          (_ctx.page == 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-outline-dark",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args))),
                  "data-bs-dismiss": "modal",
                  "aria-label": "Close"
                }, " Cancel "),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary ms-2 float-end",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
                  disabled: _ctx.submitted
                }, _toDisplayString(_ctx.submitted ? "Importing" : "Import"), 9, _hoisted_33)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}